import React, { useState, useEffect } from "react";
// import toast from 'react-hot-toast';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";
// import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

//Redux
import { useSelector, useDispatch } from "react-redux";
import { getGoodsReceivedNote } from "../../../../redux/feature/supplier_app/purchasingSlice";

//API
import ItemService from "../../../../services/supplier_appCommonService";

//Components
import Layout from "../../../../Layout/Layout";
import { InputField } from "../../../../Components/formElements/InputField";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
import Constants from "../../../../common/SupplierConstants";
import POCollabrationCommonFillter from "../../../../Components/Filter/POCollabration/POCollabrationCommonFillter";
import SuccessRegisterModal from "../../../../Components/SuccessRegisterModal";
import { currencyFormat } from "../../../../common/Validations";
import FileViewerModal from "../../../../Components/FileViewer/FileViewerModal";
import FileUploadComponent from "../../../../Components/formElements/FileUploadComponent";
import GRNInvoiceUploadModal from "./GRNInvoiceUploadModal";

const CreateGRNOcrUpload = () => {
  const dispatch = useDispatch();
  // const navigate = useNavigate();
  localStorage.setItem("menu", "Purchasing");
  localStorage.setItem("submenu", "Create GRN");

  let selectedPoDetails = useSelector(
    (state) => state?.purchasing?.purchase_order?.selectedPoDetails,
  ); // selectedPoDetails Details from Store

  let poNumber = useSelector(
    (state) => state?.purchasing?.purchase_order?.poNumber,
  ); // purchase_order from Store

  let subTransactionActivity = useSelector(
    (state) => state?.purchasing?.goods_received_note?.subTransactionActivity,
  ); // User Details from Store

  let asnNumber = useSelector(
    (state) => state?.purchasing?.goods_received_note?.asnNumber,
  ); // User Details from Store

  let asn_data = useSelector((state) => state?.purchasing?.asn?.data); // asn data Details from Store

  const modalData = {
    title: "GRN Creation",
    successMsg: "",
  };
  const [getShowSuccessModal, setShowSuccessModal] = useState(false);
  const [getModalInfo, setModalInfo] = useState(modalData);
  const [disabled, setDisabled] = useState(false);
  const [getHeaderData, setHeaderData] = useState(false);
  const [loading, setLoading] = useState(false);
  const [itemTableData, setItemTableData] = useState([]);
  const [subTotalValue, setSubTotalValue] = useState(0);

  // Invoice Upload Modal State
  const [showInvoiceModal, setShowInvoiceModal] = useState(false);

  // const [getOtherChargesValue, setOtherChargesValue] = useState(0);

  // const [getItemLevelData, setItemLevelData] = useState([]);
  // const [getItemLevelColumns, setItemLevelColumns] = useState([]);
  // const [getModalTitle, setModalTitle] = useState("");
  // const [getViewHeaderText, setViewHeaderText] = useState(false);
  // const [itemLevelModalShow, setItemLevelModalShow] = useState(false);

  const [isCardVisible, setCardVisible] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);
  const [isCardVisible3, setCardVisible3] = useState(true);

  // View attachment files
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };
  const toggleCardVisibility3 = () => {
    setCardVisible3(!isCardVisible3);
  };

  const onInputChange = ({ target: { name, value } }) => {
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
    // console.log("onInputChange => formInputs", formInputs);
  };

  const [formInputs, setFormInputs] = useState({
    subTransactionActivity: subTransactionActivity,
    documentType: "GRN",
    transactionActivity: "GRN",
    purchasingDocumentNr: poNumber,
    purchasingDocumentDate: "",
    grnStatusHeader: "Created",
    grnDate: "",
    despatchNr: "",
    despatchDate: "",
    vendorCode: "",
    vendorName: "",
    shippingType: "",
    grnRemark: "",
    grnCount: "1",
    purchasingDocumentValue: "",
    deliveredValue: "",
    deliveredStatus: "",
    invoicedValue: "",
    invoicedStatus: "",
    paidValue: "",
    currency: "",
    currencyCode: "",
    paymentTerms: "",
    deliveryNoteNr: "",
    billOfLading: "",
    incoTerms: "",
    vendorInvoiceNo: "",
    vendorInvoiceDate: "",
    vendorBasicValue: "",
    vendorTaxValue: "",
    vendorOtherChargesValue: "",
    vendorTotalInvoiceValue: "",
    vendorInvoiceCurrency: "",
    items: [
      {
        grnItemNr: "",
        materialCode: "",
        materialDescription: "",
        purchaseQuantity: "",
        grnQuantity: "",
        grnBalancePurchaseQuantity: "",
        currency: "",
        orderUnitOfMeasure: "",
        grnStatusItem: "New",
        supplierBatchNumber: "",
        plant: "",
        storeLocation: "",
        purchasingDocumentNr: "",
        purchasingDocumentItemNr: "",
        grossWeight: "",
        grnDeletionIndicator: "",
        cancellationRemarks: "",
        cancelledBy: "",
        cancelledOn: "",
        cancelledTime: "",
      },
    ],
  });

  const PriceSheduleColumns = [
    {
      name: "GRN Item Nr",
      selector: (row) => row.grnItemNr,
      sortable: true,
      width: "130px",
    },
    {
      name: "PO Item Nr",
      selector: (row) => row.purchasingDocumentItemNr,
      sortable: true,
      width: "120px",
    },
    {
      name: "Status",
      cell: (row) => (
        <>
          <span className="bg-table-status bg-table-info-status">{"New"}</span>
        </>
      ),
      width: "150px",
    },
    {
      name: "Material/Service",
      selector: (row) => row.materialCode,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row.materialCode} </p>
            <p className="m-0 p-0">{row.materialDescription} </p>
          </div>
        </>
      ),
      width: "180px",
      sortable: true,
    },
    {
      name: "Purchase Qty",
      selector: (row) => row.purchaseQuantity,
      cell: (row) => (
        <>
          <InputField
            className="inputBox mt-1"
            name="purchaseQuantity"
            value={row.purchaseQuantity}
            disabled={true}
          />
        </>
      ),
      sortable: true,
      width: "150px",
    },
    subTransactionActivity === "ASN" && {
      name: "ASN Qty",
      selector: (row) => row.asnQuantity,
      cell: (row) => (
        <>
          <InputField
            className="inputBox mt-1"
            name="asnQuantity"
            value={row.asnQuantity}
            disabled={true}
          />
        </>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "GRN Qty",
      cell: (row) => (
        <>
          <InputField
            type="number"
            className="inputBox mt-1"
            id="grnQuantity"
            name="grnQuantity"
            value={row.grnQuantity}
            onChange={(e) =>
              subTransactionActivity === "ASN"
                ? handleInputChangeTableASN(
                    row.local_id,
                    e.target.value,
                    row.asnQuantity,
                    row.orderPriceUnit,
                    row.tempAsnBalancePurchaseQuantity,
                  )
                : handleInputChangeTableGRN(
                    row.local_id,
                    e.target.value,
                    row.purchaseQuantity,
                    row.orderPriceUnit,
                    row?.grn?.grnBalancePurchaseQuantity,
                  )
            }
            disabled={
              (subTransactionActivity === "ASN"
                ? row.tempAsnBalancePurchaseQuantity
                : row?.grn?.grnBalancePurchaseQuantity) === 0
                ? true
                : false
            }
          />
        </>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "Balance Qty",
      cell: (row) => (
        <>
          <InputField
            className="inputBox mt-1"
            name={
              subTransactionActivity === "ASN"
                ? "asnBalancePurchaseQuantity"
                : "grnBalancePurchaseQuantity"
            }
            value={
              (subTransactionActivity === "ASN"
                ? row.asnBalancePurchaseQuantity
                : row.grnBalancePurchaseQuantity) || 0
            }
            disabled={true}
          />
        </>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "Oder Unit",
      selector: (row) => row.orderUnitOfMeasure,
      sortable: true,
      width: "120px",
    },
    {
      name: "Unit Price",
      // selector: (row) => row.orderPriceUnit,
      cell: (row) => (
        <span className="numberFormate">
          {currencyFormat(Number(row.orderPriceUnit).toFixed(2))}
        </span>
      ),

      sortable: true,
      width: "180px",
    },
    {
      name: "Item Value",
      selector: (row) => row.totalPrice,
      cell: (row) => (
        <>
          <InputField
            className="inputBox mt-1"
            name="totalPrice"
            value={row.totalPrice || 0}
            disabled={true}
          />
        </>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "Currency",
      selector: (row) => row.currencyCode,
      sortable: true,
      width: "120px",
    },
    {
      name: "Delivery Date",
      selector: (row) => row.deliveryDate,
      sortable: true,
      width: "140px",
    },
    {
      name: "Tax Amount",
      selector: (row) => row.taxAmount,
      sortable: true,
      width: "200px",
    },
    // {
    //   name: "Price Unit Qty",
    //   selector: (row) => row.priceUnit,
    //   sortable: true,
    //   width: "200px",
    // },
    {
      name: "Tax Code",
      selector: (row) => row.taxId,
      sortable: true,
      width: "200px",
    },
    {
      name: "Tax Desc",
      selector: (row) => row.taxIdDesc,
      sortable: true,
      width: "200px",
    },
    {
      name: "Free Of Cost",
      selector: (row) => row.freeCost,
      sortable: true,
      width: "200px",
    },
    {
      name: "PReq Nr",
      selector: (row) => row.purchaseReqNr,
      sortable: true,
      width: "200px",
    },
    {
      name: "PReq Item Nr ",
      selector: (row) => row.purchaseReqitemNr,
      sortable: true,
      width: "200px",
    },
    {
      name: "ExcessTolerance",
      selector: (row) => row.excessTolerance,
      sortable: true,
      width: "200px",
    },
    {
      name: "ShortageTolerance",
      selector: (row) => row.shortageTolerance,
      sortable: true,
      width: "200px",
    },
  ];

  const handleInputChangeTableGRN = (
    id,
    value,
    purchaseQuantity,
    orderPriceUnit,
    grnBalancePurchaseQuantity,
  ) => {
    if (Number(purchaseQuantity) >= Number(value)) {
      let totalPriceVal = Number(orderPriceUnit) * Number(value);

      if (grnBalancePurchaseQuantity) {
        if (Number(value) <= Number(grnBalancePurchaseQuantity)) {
          const updatedData = itemTableData.map((item) => {
            return item.local_id === id
              ? {
                  ...item,
                  grnQuantity: value,
                  grnBalancePurchaseQuantity: item.grn
                    .grnBalancePurchaseQuantity
                    ? Number(item.grn.grnBalancePurchaseQuantity) -
                      Number(value)
                    : Number(purchaseQuantity) - Number(value),
                  totalPrice: totalPriceVal,
                }
              : item;
          });

          setItemTableData(updatedData);
          getTotalCount(updatedData);
        }
      } else {
        const updatedData = itemTableData.map((item) => {
          return item.local_id === id
            ? {
                ...item,
                grnQuantity: value,
                grnBalancePurchaseQuantity:
                  Number(purchaseQuantity) - Number(value),
                totalPrice: totalPriceVal,
              }
            : item;
        });

        setItemTableData(updatedData);
        getTotalCount(updatedData);
      }
    } else {
      // console.log("Do Nothing");
    }
  };

  const handleInputChangeTableASN = (
    id,
    value,
    asnQuantity,
    orderPriceUnit,
    tempAsnBalancePurchaseQuantity,
  ) => {
    if (Number(asnQuantity) >= Number(value)) {
      let totalPriceVal = Number(orderPriceUnit) * Number(value);

      if (tempAsnBalancePurchaseQuantity) {
        if (Number(value) <= Number(tempAsnBalancePurchaseQuantity)) {
          const updatedData = itemTableData.map((item) => {
            return item.local_id === id
              ? {
                  ...item,
                  grnQuantity: Number(value),
                  asnBalancePurchaseQuantity: item.asnBalancePurchaseQuantity
                    ? Number(item.tempAsnBalancePurchaseQuantity) -
                      Number(value)
                    : Number(asnQuantity) - Number(value),
                  totalPrice: totalPriceVal,
                }
              : item;
          });

          setItemTableData(updatedData);
          getTotalCount(updatedData);
        }
      } else {
        const updatedData = itemTableData.map((item) => {
          return item.local_id === id
            ? {
                ...item,
                grnQuantity: value,
                asnBalancePurchaseQuantity: Number(asnQuantity) - Number(value),
                totalPrice: totalPriceVal,
              }
            : item;
        });

        setItemTableData(updatedData);
        getTotalCount(updatedData);
      }
    } else {
      // console.log("Do Nothing");
    }
  };

  // Get Total for SubTotal Pricing Schedule
  const getTotalCount = (data) => {
    const getTotal = data.reduce(
      (accumulator, currentValue) =>
        accumulator + (currentValue?.totalPrice || 0),
      0,
    );
    setSubTotalValue(getTotal);
  };

  // Core Logic
  const loadInitalPageData = async () => {
    setLoading(true);

    if (subTransactionActivity === "ASN") {
      if (asnNumber) {
        let filteredData = asn_data.filter(
          (item) => item.asnNumber === asnNumber,
        );
        // console.log(">> filteredData GRN ", filteredData);
        setHeaderData(filteredData[0]);
        let itemData = filteredData[0]?.items;

        const updateditemData = itemData.map((obj, index) => ({
          ...obj,
          grnItemNr: index + 1,
          purchasingDocumentNr: obj.purchasingDocumentNr,
          tempAsnBalancePurchaseQuantity: obj.asnBalancePurchaseQuantity,
          asnQuantity: Number(obj.asnQuantity),
          purchaseQuantity: Number(obj.purchaseQuantity),
          grnStatusItem: "In Transit",
        }));

        setItemTableData(updateditemData);
        setLoading(false);
      } else {
        // navigate(Constants.POCOLLABRATION_PURCHASE_ORDER_LIST);
        window.history.back();
      }
    } else if (subTransactionActivity === "PO") {
      if (poNumber) {
        setHeaderData(selectedPoDetails);
        let itemData = selectedPoDetails?.items;

        const updateditemData = itemData.map((obj, index) => ({
          ...obj,
          grnItemNr: index + 1,
          purchasingDocumentNr: poNumber,
          grnStatusItem: "In Transit",
        }));

        setItemTableData(updateditemData);
        setLoading(false);
      } else {
        // navigate(Constants.POCOLLABRATION_PURCHASE_ORDER_LIST);
        window.history.back();
      }
    } else {
      window.history.back();
    }
  };

  useEffect(() => {
    loadInitalPageData(); // fetch page 1 of users
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [poNumber, selectedPoDetails]);

  // SAVE
  const handleSave = async () => {
    // let requiredFields = [];

    // if(!validateRequired(formInputs?.organisationName)) {
    //   requiredFields.push('*Please enter Supplier Name');
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   return;
    // }

    // if (!validateEmail(formInputs?.email)) {
    //   requiredFields.push('*Invalid Contact Email address');
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   return;
    // }

    // if (!getPOLineItemsData[0]?.materialCode) {
    //   toast.error("Alteast one PO Line item should be added.", {
    //     duration: 4000,
    //     position: "top-right",
    //   });
    //   return;
    // }
    const userEnteredItemTableData = itemTableData.filter(
      (item) => item.grnQuantity != null,
    );
    formInputs.items = userEnteredItemTableData;

    formInputs.vendorCode = getHeaderData.vendorCode;
    formInputs.vendorName = getHeaderData.vendorName;
    formInputs.deliveredValue = getHeaderData.deliveredValue;
    formInputs.deliveredStatus = getHeaderData.deliveredStatus;
    formInputs.invoicedValue = getHeaderData.invoicedValue;
    formInputs.invoicedStatus = getHeaderData.invoicedStatus;
    formInputs.paidValue = getHeaderData.paidValue;
    formInputs.vendorInvoiceCurrency = getHeaderData.currencyCode;
    formInputs.purchasingDocumentDate = getHeaderData.purchasingDocumentDate;
    formInputs.incoTerms = getHeaderData.incoTerms;
    formInputs.paymentTerms = getHeaderData.paymentTerms;
    formInputs.purchasingDocumentValue = getHeaderData.purchasingDocumentValue;
    formInputs.currency = getHeaderData.currency;
    formInputs.currencyCode = getHeaderData.currencyCode;
    formInputs.sumOfGrn = subTotalValue;

    // console.log(">> handleSave", formInputs);

    const toastId = toast.loading("Loading...", {
      position: "top-right",
    });

    let obj = {
      data: formInputs,
    };

    setDisabled(true);
    await ItemService.addGRN(obj).then((item) => {
      // console.log(">> res!", item);
      if (item?.status === 200) {
        modalData.successMsg = item?.message;
        setModalInfo(modalData);
        onSuccessfullyRegistered();

        // Update response value in Redux Store
        dispatch(getGoodsReceivedNote());
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    toast.dismiss(toastId);
    setDisabled(false);
  };

  /* Show Success Modal */
  const onSuccessfullyRegistered = () => {
    setShowSuccessModal(true);
  };
  const hideSuccessModal = () => {
    setShowSuccessModal(false);
  };

  // For Upload Success
  const onSuccessUploadDocumentType = (data) => {
    setFormInputs((formInputs) => ({
      ...formInputs,
      [data.fieldName]: data.attachmentId,
    }));
  };

  // View attachment files
  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} lg={12} className="rightSide quoation">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={12} lg={12} className="mb-2">
                <h2 className="mainTitle">
                  {subTransactionActivity === "ASN" && (
                    <>
                      Create GRN for
                      <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                        {getHeaderData?.purchasingDocumentNr}
                      </span>
                      <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                        {asnNumber}
                      </span>
                      <span>
                        {getHeaderData?.asnStatusHeader === "ASN Cancelled" ? (
                          <span className="bg-table-status bg-table-danger-status headerStatusDetailedPage">
                            {getHeaderData?.asnStatusHeader}
                          </span>
                        ) : getHeaderData?.asnStatusHeader === "In Transit" ? (
                          <span className="bg-table-status bg-table-progress-status headerStatusDetailedPage">
                            {getHeaderData?.asnStatusHeader}
                          </span>
                        ) : getHeaderData?.asnStatusHeader ===
                          "Gatepass Created" ? (
                          <span className="bg-table-status bg-table-success-status headerStatusDetailedPage">
                            {getHeaderData?.asnStatusHeader}
                          </span>
                        ) : (
                          getHeaderData?.asnStatusHeader
                        )}
                      </span>
                    </>
                  )}
                  {subTransactionActivity === "PO" && (
                    <>
                      Create GRN for{" "}
                      <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                        {getHeaderData?.purchasingDocumentNr}
                      </span>
                      <span>
                        {getHeaderData?.statusHeader === "New" ? (
                          <span className="bg-table-status bg-table-new-status headerStatusDetailedPage">
                            {getHeaderData?.statusHeader}
                          </span>
                        ) : getHeaderData?.statusHeader === "In Release" ? (
                          <span className="bg-table-status bg-table-progress-status headerStatusDetailedPage">
                            {getHeaderData?.statusHeader}
                          </span>
                        ) : getHeaderData?.statusHeader === "Acknowledged" ? (
                          <span className="bg-table-status bg-table-success-status headerStatusDetailedPage">
                            {getHeaderData?.statusHeader}
                          </span>
                        ) : (
                          getHeaderData?.statusHeader
                        )}
                      </span>
                    </>
                  )}
                </h2>
                <p className="subText">Fill GRN Details</p>
              </Col>
              <hr />
            </Row>
            {/*Document Header Details */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">DH</span>
                    </Col>
                    <Col xs={8} md={8} lg={8}>
                      <span className="headerTitle">
                        {" "}
                        Document Header Details
                      </span>
                      <span className="subHeaderTitle">
                        Purchase Order Header Details
                      </span>
                    </Col>
                    <Col xs={2} md={2} lg={2} className="d-f justify-content-end text-no-wrap">
                      <button className="btnTable" onClick={() => setShowInvoiceModal(true)}><i className="bi bi-upload px-1"></i> Upload Invoice</button>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="">
                      <POCollabrationCommonFillter />
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Document Number"
                          name="purchasingDocumentNr"
                          placeholder=""
                          value={getHeaderData?.purchasingDocumentNr}
                          onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>

                      {/* <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Status:"
                          name="statusHeader"
                          placeholder=""
                          value={getHeaderData?.statusHeader}
                          onChange={onInputChange}
                          disabled={true}
                        />
                      </Col> */}

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Document Date"
                          name="purchasingDocumentDate"
                          placeholder=""
                          value={getHeaderData?.purchasingDocumentDate}
                          onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>

                      {/* {getHeaderData?.purchasingDocumentValue && ( */}
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Net Value"
                          name="purchasingDocumentValue"
                          placeholder=""
                          value={currencyFormat(
                            Number(
                              getHeaderData?.purchasingDocumentValue,
                            ).toFixed(2),
                          )}
                          onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Currency"
                          name="currency"
                          placeholder=""
                          value={`${getHeaderData?.currencyCode} - ${getHeaderData?.currency}`}
                          onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>
                      {/* )} */}

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Delivered Value:"
                          name="deliveredValue"
                          placeholder=""
                          id="deliveredValue"
                          value={formInputs.deliveredValue}
                          onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Delivered Status"
                          name="deliveredStatus"
                          placeholder=""
                          id="deliveredStatus"
                          value={formInputs.deliveredStatus}
                          onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Invoiced Value:"
                          name="invoicedValue"
                          placeholder=""
                          id="invoicedValue"
                          value={formInputs.invoicedValue}
                          onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Invoiced Status"
                          name="invoicedStatus"
                          placeholder=""
                          id="invoicedStatus"
                          value={formInputs.invoicedStatus}
                          onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Paid Value"
                          name="paidValue"
                          placeholder=""
                          id="paidValue"
                          value={formInputs.paidValue}
                          onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Vendor Code"
                          name="vendorCode"
                          id="vendorCode"
                          value={getHeaderData?.vendorCode}
                          onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Vendor Name"
                          name="vendorName"
                          id="vendorName"
                          value={getHeaderData?.vendorName}
                          onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Inco Terms"
                          name="incoTerms"
                          id="incoTerms"
                          value={getHeaderData?.incoTerms}
                          onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Payment Terms"
                          name="incopaymentTermsTerms"
                          id="paymentTerms"
                          value={getHeaderData?.paymentTerms}
                          onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Transaction Activity"
                          name="subTransactionActivity"
                          id="subTransactionActivity"
                          value={subTransactionActivity}
                          onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="GRN Total Amount"
                          name="sumOfGrn"
                          id="sumOfGrn"
                          value={subTotalValue}
                          // onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Delivery / Invoice No"
                          name="deliveryNoteNr"
                          id="deliveryNoteNr"
                          value={formInputs.deliveryNoteNr}
                          onChange={onInputChange}
                          disabled={false}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Bill Of Lading"
                          name="billOfLading"
                          id="billOfLading"
                          value={formInputs.billOfLading}
                          onChange={onInputChange}
                          disabled={false}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <TextAreaField
                          className="inputBox"
                          label="Delivery Remarks "
                          name="grnRemark"
                          value={formInputs.grnRemark}
                          onChange={onInputChange}
                          disabled={false}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* Price Shedule / Line Item */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible2
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility2}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">PI</span>
                    </Col>
                    <Col xs={8} md={6} lg={6}>
                      <span className="headerTitle">
                        Price Shedule / Line Item
                      </span>
                      <span className="subHeaderTitle">
                        Price Shedule / Line Item
                      </span>
                    </Col>
                    <Col xs={4} md={2} lg={2} className="">
                      <button className="btnTable">
                        <i className="bi bi-file-excel"></i>Template
                      </button>
                    </Col>
                    <Col xs={4} md={2} lg={2} className="">
                      <button
                        className="btnTable"
                        onClick={() => {
                          alert("asd");
                        }}
                      >
                        <i className="bi bi-file-excel"></i> Upload
                      </button>
                    </Col>
                    <Col xs={2} md={1} lg={1} className="">
                      <POCollabrationCommonFillter />
                    </Col>
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible2 ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          // title=""
                          columns={PriceSheduleColumns}
                          data={itemTableData}
                          progressPending={loading}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          // paginationServer
                          // paginationTotalRows={totalRows}
                          // onChangeRowsPerPage={handlePerRowsChange}
                          // onChangePage={handlePageChange}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/*grn attachments*/}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible3
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility3}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">QH</span>
                    </Col>
                    <Col xs={12} md={9} lg={9}>
                      <span className="headerTitle">GRN Attachment</span>
                      <span className="subHeaderTitle">GRN Attachment</span>
                    </Col>

                    <Col xs={2} md={1} lg={1} className="">
                      <POCollabrationCommonFillter />
                    </Col>
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible3 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4 d-flex justify-content-between">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <FileUploadComponent
                          id="shippingDocuments"
                          name="shippingDocuments"
                          label="Shipping Documents"
                          allowedTypes={[
                            "image/png",
                            "image/jpeg",
                            "application/pdf",
                          ]}
                          multiple={true} // Change to false for single file selection
                          required={true}
                          onSuccessUpload={onSuccessUploadDocumentType}
                          value={formInputs?.shippingDocuments || ""}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={1}
                        lg={1}
                        className="commTopButtonRightLeftPadding d-flex align-items-center"
                      >
                        {(formInputs?.shippingDocuments && (
                          <img
                            src="assets/img/newIcons/attached-file.png"
                            className="mt-1 attachmentIcon"
                            alt="attachments"
                            onClick={() =>
                              handleViewFile(formInputs?.shippingDocuments)
                            }
                          />
                        )) ||
                          "--"}
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <FileUploadComponent
                          id="otherAttachments"
                          name="otherAttachments "
                          label="Other Attachments"
                          allowedTypes={[
                            "image/png",
                            "image/jpeg",
                            "application/pdf",
                          ]}
                          multiple={true} // Change to false for single file selection
                          required={true}
                          onSuccessUpload={onSuccessUploadDocumentType}
                          value={formInputs?.otherAttachments || ""}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={1}
                        lg={1}
                        className="commTopButtonRightLeftPadding d-flex align-items-center"
                      >
                        {(formInputs?.shippingDocuments && (
                          <img
                            src="assets/img/newIcons/attached-file.png"
                            className="mt-1 attachmentIcon"
                            alt="attachments"
                            onClick={() =>
                              handleViewFile(formInputs?.otherAttachments)
                            }
                          />
                        )) ||
                          "--"}
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* buttons */}
          <div className="pageFooter">
            <Row className="rowDirection">
              <Col xs={12} md={2} lg={2} className="">
                <button
                  className="btn w-full"
                  onClick={handleSave}
                  disabled={disabled}
                >
                  <i className="bi bi-save"></i> Create
                </button>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>

      <SuccessRegisterModal
        show={getShowSuccessModal}
        onHide={() => hideSuccessModal()}
        modaldata={getModalInfo}
        aftersuccess={
          subTransactionActivity === "ASN"
            ? Constants.POCOLLABRATION_ASN
            : Constants.POCOLLABRATION_PURCHASE_ORDER_DETAIL_PAGE
        }
      />
      <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      />
      <GRNInvoiceUploadModal
        show={showInvoiceModal}
        onHide={() => setShowInvoiceModal(false)}
        invoiceinfo={getHeaderData}
        poNumber={poNumber}
        selectedPoDetails={selectedPoDetails}
        onsuccessdata={(data) => {
          // Handle successful invoice creation - refresh GRN data if needed
          console.log("Invoice created successfully:", data);
        }}
      />
    </main>
  );
};

export default CreateGRNOcrUpload;
